export class SnapshotTimeFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_from",
            "baseName": "from",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "to",
            "baseName": "to",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return SnapshotTimeFilters.attributeTypeMap;
    }
    constructor() {
    }
}
